module.exports = JSON.parse('{"Primary":"Primary","Recent":"Recent","All":"All"}')